<template>
  <!-- <div id="watchlistSeeAll" class="watchlist" :dir="[localDisplayLang === 'ara' ? 'rtl' : 'ltr']">
    <div v-if="isLoading">
      <div v-for="(item, index) in 2" :key="index">
        <categoriesPlaceholder></categoriesPlaceholder>
      </div>
    </div>
    <LoadingComponent  v-if="isLoaderEnabled" :size="'50px'"></LoadingComponent>
    <div>
      <div
        v-if="finalPlaylistMovies.length === 0 &&
            !isLoading">
        <p class="empty-message first-message">{{ mylistEmpty }}</p>
        <p class="empty-message">{{ mylistEmptySubTitle }}</p>

      </div>
      <div class="container" style="position:relative">
          <div class="watchlist-grids">
            <watchlistGridCard
              :contents="finalPlaylistMovies"
              @removedWatchlistContent="checkWatchlistContent"
            ></watchlistGridCard>
          </div>
        </div>
    </div>
  </div> -->
  <div class="collection" id="watchlistSeeAll">
    <div class="collection-title">
      <h2>{{ $t('Watch List') }}</h2>
    </div>
      <div v-if="finalPlaylistMovies.length === 0 && !isLoading">
        <p class="empty-message first-message">{{ mylistEmpty }}</p>
        <p class="empty-message">{{ mylistEmptySubTitle }}</p>
      </div>
    <Grid :contents="finalPlaylistMovies" :displayType="'LANDSCAPE'"
      :isScrollable="isScrollable" @loadMore="loadMoreContents()" :showRemove="true"
      @remove="checkWatchlistContent" v-if="!isLoading"></Grid>
    <div v-else>
      <GridLayoutPlaceholder :displayType="'LANDSCAPE'"></GridLayoutPlaceholder>
    </div>
    <div v-if="isLoaderEnabled" class="loader_wraper">
      <LoadingComponent  :size="'50px'"></LoadingComponent>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getDatabase, ref, get } from "firebase/database";
import Utility from "@/mixins/Utility.js";
import { eventBus } from "@/eventBus";
import FirebaseActions from "@/mixins/FirebaseActions";


export default {
  props: {
    menuDetail: {
      type: Object,
    },
  },
  data() {
    return {
      menuTitle: null,
      watchContents: false,

      watchlistContent: [],
      categorizedMovieContent: [],
      categorisedTvshow: [],
      categories: [],
      filteredContents: [],
      playlist: [],
      menuDetailItem: null,
      localDisplayLang: null,
      mylistEmpty: "",
      mylistEmptySubTitle: "",
      detailPlaylist: [],
      finalPlaylist: [],
      totalContents: [],

      finalPlaylistSeries: false,
      finalPlaylistMovies: false,

      firebaseInstance: null,

      moviesReload: false,
      seriesReload: false,

      isLoading: false,
      noContentsInWatchlist: false,
      isLoaderEnabled:false,
      mixedWatchlist: []
    };
  },
  watch: {
    localDisplayLang(val) {
      if (val) {
        this.mylistEmpty = this.$t("Your watchlist is Empty");
        this.mylistEmptySubTitle = this.$t(
          "Add your favorite content that you want to watch later"
        );
      }
    },
    detailPlaylist(val) {
      if (val.length === this.playlist.length) {
        this.finalPlaylist = val.map((item, i) =>
          Object.assign({}, item, this.playlist[i])
        );
        this.finalPlaylist = this.finalPlaylist.sort((a, b) => {
          return b.watchlistupdatedat - a.watchlistupdatedat;
        });
        
        this.watchContents = true;
      }
    },
  },
  computed: {
    ...mapGetters(["appConfig", "subscriberid", "profileid"]),

    locale() {
      
      return this.$i18n.locale;
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.mylistEmpty = this.$t("Your watchlist is Empty");
    this.mylistEmptySubTitle = this.$t(
      "Add your favorite content that you want to watch later"
    );

    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");

    //checking for change of language in local storage value
    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLang = data;

      this.menuTitle = this.localDisplayLang === "ara" ? "نوربلاي" : "My List";

      

      this.checkPlaylist();
    });

    this.menuTitle = this.localDisplayLang === "ara" ? "نوربلاي" : "My List";

    // eventBus.$on(`contents-for-watchlist`, (response) => {
    //   // console.log("content detail response", response);
    //   this.detailPlaylist.push(response);
    //   // console.log("detailPlaylist-------->", this.detailPlaylist);
    // });
  },

  mounted() {
    this.checkPlaylist();

    eventBus.$on("on-watchlist-state-change", () => {
      
      this.checkPlaylist();
    });
  },

  methods: {
    ...mapActions(["listBundleItem", "listContent"]),

    checkPlaylist(isDelete = false) {
      if (isDelete) {
        this.isLoaderEnabled = true;
      } else {
        this.isLoading = true;
      }

      const db = getDatabase();
      const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;
      const contentRef = ref(db, path);

      get(contentRef)
        .then((snapshot) => {
          if (!snapshot.exists()) {
            this.finalPlaylistMovies = [];
            this.finalPlaylistSeries = [];
            this.isLoading = false;
            this.isLoaderEnabled = false;
            return;
          }

          const nodeContentArr = this.collectionsToArray(snapshot.val());
          const totalContents = nodeContentArr.filter((element) => element.inwatchlist);

          if (totalContents.length === 0) {
            this.finalPlaylistMovies = [];
            this.finalPlaylistSeries = [];
            this.isLoading = false;
            this.isLoaderEnabled = false;
            return;
          }

          this.totalContents = totalContents;

          if (this.totalContents && this.totalContents.length > 0) {
            // this.makeTheWatchlistAPIcall();
            this.makeTheWatchlistAPIcallClub();
          } else {
            this.noContentsInWatchlist = true;
            this.isLoading = false;
            this.isLoaderEnabled = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching playlist:", error);
          this.isLoading = false;
          this.isLoaderEnabled = false;
        });
    },
    makeTheWatchlistAPIcallClub() {
      let ObjectIdArr = [];

      this.totalContents.forEach((element, index) => {
        ObjectIdArr.push(`"${element.objectid}"`)
      });

      if (ObjectIdArr && ObjectIdArr.length > 0) {
  
        let payload = {
          contentlist: "[" + `${ObjectIdArr}` + "]",
          displaylanguage: this.localDisplayLang,
          notincontentprovider: ["hotgo"],
          pagesize: 100
        };

        this.listContent(payload).then((data) => {
          this.finalPlaylistMovies = data.data.data ? data.data.data : [];

          this.isLoaderEnabled = false
          if (this.isLoading) {
            this.isLoading = false;
          }

        })

      }


    },
    makeTheWatchlistAPIcall() {
      let seriesObjectIdArr = [];
      let moviesObjectIdArr = [];

      this.totalContents.forEach((element, index) => {
        if (element.category === "MOVIE") {
          moviesObjectIdArr.push(`"${element.objectid}"`);
        } else if (element.category === "TVSHOW") {
          seriesObjectIdArr.push(`"${element.objectid}"`);
        }
      });

      if (moviesObjectIdArr && moviesObjectIdArr.length > 0) {
  
        let payload = {
          objecttype: "CONTENT",
          contentlist: "[" + `${moviesObjectIdArr}` + "]",
          displaylanguage: this.localDisplayLang,
        };

        this.listContent(payload).then((data) => {
          this.finalPlaylistMovies = data.data.data;

          

          if (seriesObjectIdArr && seriesObjectIdArr.length > 0) {
        let payloadSeries = {
          contentlist: "[" + `${seriesObjectIdArr}` + "]",
          displaylanguage: this.localDisplayLang,
        };

        this.listContent(payloadSeries).then((data) => {
          this.finalPlaylistSeries = data.data.data;

          if (!this.finalPlaylistSeries) {
            this.finalPlaylistSeries = [];
          }


          this.isLoaderEnabled = false
          if (this.isLoading) {
            this.isLoading = false;
          }
        });
      } else {
        this.finalPlaylistSeries = [];
      }

      
          this.isLoaderEnabled = false
          if (this.isLoading) {
            this.isLoading = false;
          }
        });
      } else {
        this.finalPlaylistMovies = [];
      }

 

      this.isLoading = false;

    },

    showEmptyMessage() {
      // this.watchContents = true;
      setTimeout(() => {
        this.setTimeout = false;
        this.watchlistContent = null;
      }, 4000);
    },

    checkWatchlistContent(data) {
      this.updateContentWatchlist(data, false).then(() => {
       this.checkPlaylist(true);
      });
    },

    initialRoute() {
      this.$router.push({ name: "Home" });
    },
  },

  beforeDestroy() {
    

    eventBus.$off("on-watchlist-state-change");
    eventBus.$off("check-local-storage");

    this.firebaseInstance.off("value", (data) => {
      console.log("THE FIREBASE DATABASE EVENT IS OFF", data);
    });
  },

  components: {
    categoriesPlaceholder: () =>
      import(
        /* webpackChunkName: "categoriesPlaceholder" */ "@/components/placeholders/categoriesPlaceholder.vue"
      ),
    watchlistGridCard: () =>
      import(/* webpackChunkName: "itemListTemp" */ "./watchlistGridCards.vue"),
    LoadingComponent: () => import(/* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"),
    GridLayoutPlaceholder: () => import(/* webpackChunkName: "gridplaceholder" */ "@/components/placeholders/GridLayoutPlaceholder.vue"),
    Grid: () => import(/* webpackChunkName: "Grid" */ "@/components/Templates/GridLayout.vue"),

  },
  mixins: [Utility, FirebaseActions],
};
</script>

<style lang="scss" scoped>
@use "@/sass/_variables.scss" as *;
@import "./watchlist.scss";
.collection {
  width: clamp(2rem, 100%, 95%);
  margin: 4rem auto auto auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .collection-title {
    padding: 0.5rem 2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.7;
  }

  .gridMainLayout {
    padding-top: 0 !important;
  }
}

@media screen and (max-width:1023px) {
  .collection {
    margin-top: 4rem;
  }
}

.loader_wraper {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background: rgba(46, 45, 45, 0.436);
}
</style>
